import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import { useState } from 'react';
import { Button, Form, Spinner, Image, Modal } from 'react-bootstrap';
const viewportWidth = window.innerWidth;

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

interface PdfViewerProps {
  handleClose?: () => void; // Function prop
  show?: boolean; // Boolean prop
  terms_n_condition: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ show, handleClose, terms_n_condition }) => {
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);

  const next = () => {
    setPageNumber((prevState) => {
      return prevState + 1;
    });
  };

  const prev = () => {
    setPageNumber((prevState) => {
      return prevState - 1;
    });
  };

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  return (
    <Modal contentClassName="modal-content" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Terms and Condition</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Document file={terms_n_condition} onLoadSuccess={onDocumentLoadSuccess}>
            <Page scale={viewportWidth > 800 ? 0.8 : 0.5} pageNumber={pageNumber} />
          </Document>
        </div>
      </Modal.Body>
      <Modal.Footer className='footer'>
        <p>
          Page {pageNumber} of {numPages}
        </p>
        <div>
          <Button
            disabled={pageNumber == 1 ? true : false}
            onClick={() => {
              prev();
            }}
          >
            Prev
          </Button>

          <Button
            disabled={pageNumber == numPages ? true : false}
            onClick={() => {
              next();
            }}
          >
            Next
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PdfViewer;
